import React, { memo } from "react";
import Icon from "../../assets/icons/Icon";

const Button = ({
  className,
  children,
  icon = null,
  onClick,
  disabled = false,
  ...props
}) => {
  return (
    <button
      className={`btn ${className}`}
      style={{ cursor: disabled ? "not-allowed" : "pointer" }}
      onClick={onClick}
      onFocus={(e) => e.target.blur()}
      disabled={disabled}
      {...props}
    >
      {children}
      {icon ? <Icon name={icon} /> : null}
    </button>
  );
};

export default memo(Button);
